// Nowcast offsets in minutes (matching Cloud Function NOWCAST_MINUTES)
export const NOWCAST_OFFSETS = [5, 10, 15, 20, 25, 29];

// Tomorrow.io tiles gradient definition for precipitation intensity (Rain)
export const TIO_PRECIPITATION_GRADIENT = [
  { value: 0, opacity: 0, hexColor: '#95dd84' },
  { value: 0.01, opacity: 26, hexColor: '#95dd84' },
  { value: 0.086, opacity: 51, hexColor: '#95dd84' },
  { value: 0.154, opacity: 153, hexColor: '#95dd84' },
  { value: 0.237, opacity: 204, hexColor: '#95dd84' },
  { value: 0.365, opacity: 255, hexColor: '#6fff00' },
  { value: 0.562, opacity: 255, hexColor: '#5add03' },
  { value: 0.865, opacity: 255, hexColor: '#45bc03' },
  { value: 1.332, opacity: 255, hexColor: '#339b02' },
  { value: 2.05, opacity: 255, hexColor: '#217c00' },
  { value: 3.158, opacity: 255, hexColor: '#fffb00' },
  { value: 4.862, opacity: 255, hexColor: '#ffe700' },
  { value: 7.488, opacity: 255, hexColor: '#ffb700' },
  { value: 11.531, opacity: 255, hexColor: '#ff8900' },
  { value: 17.756, opacity: 255, hexColor: '#ff4d00' },
  { value: 27.344, opacity: 255, hexColor: '#dd2f04' },
  { value: 42.107, opacity: 255, hexColor: '#bb0505' },
  { value: 50, opacity: 255, hexColor: '#79160e' },
];

// Tomorrow.io tiles gradient definition for snow
export const TIO_SNOW_GRADIENT = [
  { value: 0, opacity: 0, hexColor: '#D7F1F3' },
  { value: 0.01, opacity: 26, hexColor: '#B4E7ED' },
  { value: 0.086, opacity: 51, hexColor: '#09E2F6' },
  { value: 0.154, opacity: 153, hexColor: '#08D3E6' },
  { value: 0.237, opacity: 204, hexColor: '#08C3D6' },
  { value: 0.365, opacity: 255, hexColor: '#07B4C6' },
  { value: 0.562, opacity: 255, hexColor: '#07A6B6' },
  { value: 0.865, opacity: 255, hexColor: '#0697A6' },
  { value: 1.332, opacity: 255, hexColor: '#058491' },
  { value: 2.05, opacity: 255, hexColor: '#04656F' },
  { value: 3.158, opacity: 255, hexColor: '#1F3A48' },
  { value: 4.862, opacity: 255, hexColor: '#172E3A' },
  { value: 7.488, opacity: 255, hexColor: '#10222D' },
  { value: 11.531, opacity: 255, hexColor: '#D029D0' },
  { value: 17.756, opacity: 255, hexColor: '#E06EDC' },
  { value: 27.344, opacity: 255, hexColor: '#EDA1E8' },
  { value: 42.107, opacity: 255, hexColor: '#F8D0F4' },
  { value: 50, opacity: 255, hexColor: '#ECDEEA' },
];

// Tomorrow.io tiles gradient definition for freezing rain
export const TIO_FREEZING_RAIN_GRADIENT = [
  { value: 0, opacity: 0, hexColor: '#F0C4DB' },
  { value: 0.01, opacity: 26, hexColor: '#ECBDD5' },
  { value: 0.086, opacity: 51, hexColor: '#E8B6D0' },
  { value: 0.154, opacity: 153, hexColor: '#E3B0CA' },
  { value: 0.237, opacity: 204, hexColor: '#DFA9C5' },
  { value: 0.365, opacity: 255, hexColor: '#CB73A1' },
  { value: 0.562, opacity: 255, hexColor: '#C66E9C' },
  { value: 0.865, opacity: 255, hexColor: '#C06896' },
  { value: 1.332, opacity: 255, hexColor: '#BB6391' },
  { value: 2.05, opacity: 255, hexColor: '#B65E8C' },
  { value: 3.158, opacity: 255, hexColor: '#894263' },
  { value: 4.862, opacity: 255, hexColor: '#7F3A5A' },
  { value: 7.488, opacity: 255, hexColor: '#753251' },
  { value: 11.531, opacity: 255, hexColor: '#521B33' },
  { value: 17.756, opacity: 255, hexColor: '#4F1931' },
  { value: 27.344, opacity: 255, hexColor: '#4D182F' },
  { value: 42.107, opacity: 255, hexColor: '#4A162D' },
  { value: 50, opacity: 255, hexColor: '#48152B' },
];

// Tomorrow.io tiles gradient definition for sleet
export const TIO_SLEET_GRADIENT = [
  { value: 0, opacity: 0, hexColor: '#E1D3FD' },
  { value: 0.01, opacity: 26, hexColor: '#DCCCFC' },
  { value: 0.086, opacity: 51, hexColor: '#D7C4FB' },
  { value: 0.154, opacity: 153, hexColor: '#D1BDF9' },
  { value: 0.237, opacity: 204, hexColor: '#CCB6F8' },
  { value: 0.365, opacity: 255, hexColor: '#A392D3' },
  { value: 0.562, opacity: 255, hexColor: '#9E8CD1' },
  { value: 0.865, opacity: 255, hexColor: '#9985D0' },
  { value: 1.332, opacity: 255, hexColor: '#947FCE' },
  { value: 2.05, opacity: 255, hexColor: '#8F79CC' },
  { value: 3.158, opacity: 255, hexColor: '#67588D' },
  { value: 4.862, opacity: 255, hexColor: '#615288' },
  { value: 7.488, opacity: 255, hexColor: '#5C4C84' },
  { value: 11.531, opacity: 255, hexColor: '#4A3D6C' },
  { value: 17.756, opacity: 255, hexColor: '#473A69' },
  { value: 27.344, opacity: 255, hexColor: '#443767' },
  { value: 42.107, opacity: 255, hexColor: '#423464' },
  { value: 50, opacity: 255, hexColor: '#3F3162' },
];

// Marshall-Palmer gradient for Tomorrow.io Map Tiles API `gradient` query parameter.
// Positions are actual rain-rate values in mm/h (matching MARSHALL_PALMER_SCALE).
// Paired stops at each boundary create hard color transitions (discrete bands).
// Format per stop: "position:RRGGBBAA"
export const MARSHALL_PALMER_TIO_GRADIENT = [
  '0:00000000',
  '0.1:4A0682FF', '0.2:4A0682FF',
  '0.3:9402D3FF', '0.5:9402D3FF',
  '0.6:DDA0DDFF', '1:DDA0DDFF',
  '1.1:00FFFFFF', '2:00FFFFFF',
  '2.1:6395EDFF', '3:6395EDFF',
  '3.1:006400FF', '6:006400FF',
  '6.1:33CD32FF', '10:33CD32FF',
  '10.1:FFFD05FF', '15:FFFD05FF',
  '15.1:FF8C00FF', '25:FF8C00FF',
  '25.1:B00001FF', '50:B00001FF',
  '50.1:000000FF',
].join(', ');

// Marshall-Palmer rain rate scale — matches radar-l2-processor colormaps.py get_marshall_palmer_lut()
export const MARSHALL_PALMER_SCALE = [
  { maxValue: 0.1,  label: '0.1',  color: '#4A0682' },
  { maxValue: 0.2,  label: '0.2',  color: '#9402D3' },
  { maxValue: 0.5,  label: '0.5',  color: '#DDA0DD' },
  { maxValue: 1,    label: '1',    color: '#00FFFF' },
  { maxValue: 2,    label: '2',    color: '#6395ED' },
  { maxValue: 3,    label: '3',    color: '#006400' },
  { maxValue: 6,    label: '6',    color: '#33CD32' },
  { maxValue: 10,   label: '10',   color: '#FFFD05' },
  { maxValue: 15,   label: '15',   color: '#FF8C00' },
  { maxValue: 25,   label: '25',   color: '#B00001' },
  { maxValue: 50,   label: '50',   color: '#000000' },
];
